import styled from 'styled-components';
import { Checkbox } from 'antd';

export const CheckboxText = styled(Checkbox)`
	.ant-checkbox {
		display: none;
	}

	span {
		font-size: 0.9rem;
		color: ${({ theme }) => theme.colors.primary};
	}
`;
